<template>
  <div class="d-flex flex-wrap align-items-center gap-2 w-100">
    <div class="d-flex flex-wrap align-items-center me-auto mb-2 mb-md-0">
      <div class="bg-white shadow justify-content-center align-items-center px-1 me-3 rounded-2">
        <a @click="changeModelViewType(modelViewType.kanban)"
          :class="route.query.viewType === modelViewType.kanban ? 'active' : ''"
          class="btn btn-sm btn-outline-primary text-active-white text-hover-white btn-icon me-1"
          :title="$t('tooltip.pipeline.kanban')"
        >
          <i class="bi bi-grid-fill fs-4 text-primary"></i>
        </a>
        <a @click="changeModelViewType(modelViewType.list)"
          :class="route.query.viewType === modelViewType.list ? 'active' : ''"
          class="btn btn-sm btn-outline-primary text-active-white text-hover-white btn-icon"
          :title="$t('tooltip.pipeline.list')"
        >
          <i class="bi bi-list-task fs-4 text-primary"></i>
        </a>
        
      </div>
      <div class="d-flex align-items-center flex-wrap gap-2">
        <button  v-show="route.query.viewType === modelViewType.prevision" id="kt_td_picker_button" class="btn btn-sm btn-flex btn-outline-primary fw-bolder shadow-sm border text-hover-white">
          <i class="fa fa-filter text-primary"></i>
          <span class="mx-2">{{ new Date(query.year).getFullYear() }}</span>
          <i class="fa fa-angle-down text-primary fs-2"></i>
        </button>
        <OutlineButton btn-class="btn-sm me-2"v-if="$can(abilities.EXPORT_OPPORTUNITIES)" icon-class="fas fa-download" type="primary" :border="true" id="submit_btn" btn-text="contacts.export" @click="exportPipelineFile" :isLoading="isLoading"></OutlineButton>
        <ButtonDropdownFilter
            :btn-title="$t('button.all_status')"
            :search="false"
            :options="filterOpportunityStatus"
            value-field="value"
            :name-field="locale"
            v-model="query.status"
        />
        <ButtonDropdownFilter
            :btn-title="$t('label.allContacts')"
            :options="[...contacts]"
            value-field="id"
            name-field="fullname"
            v-model="query.contact"
        />
        <ButtonDropdownFilter
            :btn-title="$t('label.allSellers')"
            :options="[...salesPersons]"
            value-field="id"
            name-field="fullname"
            v-model="query.seller"
        />
        <ButtonDropdownFilter
            :btn-title="$t('label.Priorities')"
            :options="[...pipelinePriorities]"
            value-field="value"
            :name-field="locale"
            v-model="query.priority"
        />
      </div>
    </div>

    <div class="d-flex align-items-center mt-2 mt-md-0">
      <Input
          v-if="showSearch"
          container-class="me-2"
          size="sm"
          inputClass="form-control form-control-sm"
          name="input-search"
          :isInputGroup="true"
          :placeholder="$t('label.search')"
          v-model="query.search"
      >
        <template #rightAddon>
          <span class="position-absolute border-0 bg-transparent end-0 top-50 translate-middle">
            <i class="fa fa-search"></i>
          </span>
        </template>
      </Input>

      <DateRangePicker :id="id" @update:date="handleRangeDate" v-if="route.query.viewType !== modelViewType.prevision" />

     <!--  <a @click="changeModelViewType(modelViewType.prevision)"
        :class="route.query.viewType === modelViewType.prevision ? 'active' : ''"
        class="btn btn-icon btn-sm btn-outline-primary text-active-white text-hover-white shadow border me-2"
        :title="$t('tooltip.pipeline.prevision')">
        <i class="fas fa-list-alt text-primary fs-4"></i>
      </a> -->
      <a @click.prevent="goToStatistic"
        class="btn btn-icon btn-sm btn-outline-primary text-active-white text-hover-white shadow border"
        v-if="$can(abilities.VIEW_STATS_OPPORTUNITIES)"
        :title="$t('tooltip.pipeline.chart')">
        <i class="fas fa-chart-line text-primary fs-4"></i>
      </a>
    </div>
  </div>
</template>
<script setup>
import Input from "@/components/Input.vue";
import ButtonDropdownFilter from "@/components/ButtonDropdownFilter.vue";
import {useModelViewType} from "@/composables/modelViewType";
import {computed, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import Button from "@/components/Button";
import * as tempusDominus from "@eonasdan/tempus-dominus";
import {useLocales} from "@/composables/locales";
import OutlineButton from "@/components/OutlineButton";
import DateRangePicker from "@/components/DateRangePicker.vue";
import abilities from "@/composables/abilities";

const store = useStore()
const router = useRouter()
const route = useRoute()
const { modelViewType } = useModelViewType()

const { locale } = useLocales()

const props = defineProps({
  handleRangeDate: {type: Function, default: () => {}},
  query: {type: Object, default: {startDate: '',endDate: '',search: '',status: '',contact: '',priority: ''}},
  showSearch: {type: Boolean, default: true}
})

const isLoading = ref(false)

const query = ref(props.query)
const opportunityStatus = computed(() => store.getters['pipelines/pipelineStatusEnum'])
const filterOpportunityStatus = computed(() => opportunityStatus.value.filter(status => status.value !== 'NEW'))
const contacts = computed(() => store.getters['contacts/getContacts'])
const salesPersons = computed(() => store.getters['pipelines/getSalesPersons'])
const pipelinePriorities = computed(() => {
  const priorities = store.getters['pipelines/pipelinePriorityEnum'];

  return priorities.filter(priority => priority.value !== 0);
});

function changeModelViewType (viewType) {
  router.push({ query: { viewType } });
}

async function exportPipelineFile(){
  try {
    isLoading.value = true
    await store.dispatch('pipelines/exportPipeline')
  } catch (e) { }
  isLoading.value = false
}

function goToStatistic(){
  router.push({name: 'pipelines-chart'})
}

</script>
<style scoped>
@import "@eonasdan/tempus-dominus/dist/css/tempus-dominus.min.css";


</style>
